export default __webpack_public_path__ + "static/media/phone-app-stock.7b187a66.png";